'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.keyBindingFn = keyBindingFn;

var _draftJs = require('draft-js');

/**
 * Handle default key bindings.
 *
 * @param {Event} event
 * @return {String} defaultCommand
 */
function keyBindingFn(event) {
  return (0, _draftJs.getDefaultKeyBinding)(event);
}


//////////////////
// WEBPACK FOOTER
// ./~/draft-js-plugins-editor/lib/Editor/defaultKeyBindingPlugin.js
// module id = 509
// module chunks = 0